import { getLocalStorageEntry, setLocalStorageEntry } from './webStorageUtils';

export type SavedLearnableSource =
  { type: 'localVideo'; localName: string | null } | { type: 'search' } | { type: 'myWords' };

type SourcesByLearnableId = Record<string, SavedLearnableSource>;

const storageKey = (languagePairId: number) => `SAVED_LEARNABLE_SOURCES_${languagePairId}`;

const readSources = (languagePairId: number): SourcesByLearnableId => {
  const stored = getLocalStorageEntry(storageKey(languagePairId));
  if (!stored) return {};
  try {
    const sources: unknown = JSON.parse(stored);
    return sources && typeof sources === 'object' && !Array.isArray(sources)
      ? (sources as SourcesByLearnableId)
      : {};
  } catch {
    return {};
  }
};

/**
 * The backend doesn't record where a word was saved from yet,
 * so this browser remembers it to show on the Saved tab.
 */
export const getSavedLearnableSource = (
  languagePairId: number,
  learnableId: number,
): SavedLearnableSource | null => readSources(languagePairId)[learnableId] ?? null;

export const setSavedLearnableSource = (
  languagePairId: number,
  learnableId: number,
  source: SavedLearnableSource | null,
) => {
  const { [learnableId]: _previous, ...sources } = readSources(languagePairId);
  setLocalStorageEntry(
    storageKey(languagePairId),
    JSON.stringify(source ? { ...sources, [learnableId]: source } : sources),
  );
};
